import React from 'react';
import SeoFaq from '../../../../../shared/pages/HomePage/containers/SeoFaq';
import {useSelector} from 'react-redux';
import {processedFaqDataSelector} from '../../../../../shared/pages/DetailsPage/selectors/index';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

const SEOFaqDetails = () => {
  const faqData = useSelector(processedFaqDataSelector);

  if (!(!!faqData?.faq_content && !!faqData?.faq_content.length)) return null;
  return <SeoFaq datakey={'dh_detail_json'} faqData={faqData} id={detailsNavigationIds.faqs} />;
};

export default SEOFaqDetails;
